import React from 'react';
import LazyLoad from 'react-lazyload';
import AvatarPlaceHolder from '../../../public/images/icon-avatar.png';

export const Avatar = (props) => {
  const { imgSrc, caption } = props;
  return (
    <LazyLoad>
      <img
                // data-src={imgSrc || AvatarPlaceHolder}
                src={imgSrc || AvatarPlaceHolder}
                alt={caption}
                className="avatar" />
    </LazyLoad>
  );
};
 
export default Avatar;
